/**
 * Copyright (c) 2020
 *
 * @summary calls to customersManager/refreshToken
 * @author Julien <julien.donnadieu@yooda.com>
 *
 * Created at     : 2020-06-08 10:21:56
 * Last modified  : 2020-06-26 15:31:17
 */

import axios from '@/api/axios.js'

export default {

    /**
     * @returns Promise
     */
    refreshToken () {
        return axios.post('/customers-manager/token/refresh')
    },

};
